<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>Validation requise</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div class="modal-container">
    <!-- Icon & Title -->
    <div class="modal-header">
      <div class="icon-container">
        <ion-icon name="mail-outline" color="primary"></ion-icon>
      </div>
      <h2>Email étudiant requis</h2>
      <p class="explanation">{{ explanationMessage }}</p>
    </div>

    <!-- Step 1: Email Entry -->
    @if (currentStep() === 'email') {
      <div class="step-content">
        <div class="input-section">
          <label class="input-label">Votre email universitaire</label>
          <ion-input
            [(ngModel)]="studentEmail"
            type="email"
            placeholder="prenom.nom@univ.fr"
            [disabled]="isLoading()"
            class="student-email-input"
          ></ion-input>
          <p class="input-hint">
            <ion-icon name="information-circle-outline"></ion-icon>
            Utilisez votre email universitaire (se termine généralement par .univ.fr ou .edu)
          </p>
        </div>

        @if (errorMessage()) {
          <div class="error-message">
            <ion-icon name="alert-circle-outline"></ion-icon>
            <span>{{ errorMessage() }}</span>
          </div>
        }

        @if (isDomainNotRecognized()) {
          <div class="domain-request-info">
            <ion-icon name="help-circle-outline"></ion-icon>
            <div>
              <p>Votre domaine d'email n'est pas encore dans notre liste ?</p>
              <p>
                Envoyez une demande d'ajout a
                <a href="mailto:communication@chezandre.fr?subject=Demande%20ajout%20domaine%20email%20etudiant&body=Bonjour,%0A%0AJe%20souhaite%20faire%20ajouter%20mon%20domaine%20email%20etudiant%20a%20la%20liste%20des%20domaines%20reconnus%20par%20La%20BASE.%0A%0AEmail%20etudiant%20:%20{{ studentEmail() }}%0AEtablissement%20:%20[Nom%20de%20votre%20etablissement]%0A%0AMerci%20!">
                  communication@chezandre.fr
                </a>
              </p>
            </div>
          </div>
        }

        <ion-button
          expand="block"
          (click)="sendOTP()"
          [disabled]="isLoading() || !studentEmail()"
          class="primary-button"
        >
          @if (isLoading()) {
            <ion-spinner name="crescent"></ion-spinner>
          } @else {
            Envoyer le code de vérification
          }
        </ion-button>
      </div>
    }

    <!-- Step 2: OTP Verification -->
    @if (currentStep() === 'otp') {
      <div class="step-content">
        <div class="otp-section">
          <p class="otp-info">
            Un code de vérification à 6 chiffres a été envoyé à:<br>
            <strong>{{ studentEmail() }}</strong>
          </p>

          <app-otp-input
            [length]="6"
            (otpChange)="onOtpChange($event)"
            (otpComplete)="onOtpComplete()"
          ></app-otp-input>

          @if (errorMessage()) {
            <div class="error-message">
              <ion-icon name="alert-circle-outline"></ion-icon>
              <span>{{ errorMessage() }}</span>
            </div>
          }

          <ion-button
            expand="block"
            (click)="verifyOTP()"
            [disabled]="isLoading() || otpCode().length !== 6"
            class="primary-button"
          >
            @if (isLoading()) {
              <ion-spinner name="crescent"></ion-spinner>
            } @else {
              Vérifier le code
            }
          </ion-button>

          <button class="text-button" (click)="goBackToEmail()" [disabled]="isLoading()">
            <ion-icon name="arrow-back-outline"></ion-icon>
            Changer d'email
          </button>
        </div>
      </div>
    }

    <!-- Info Footer -->
    <div class="modal-footer">
      <ion-icon name="shield-checkmark-outline"></ion-icon>
      <p>Cette vérification garantit que vous êtes étudiant(e) et protège votre accès à La BASE.</p>
    </div>
  </div>
</ion-content>
